import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ReportConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ReportService } from './api/report.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ReportApiModule {
    public static forRoot(configurationFactory: () => ReportConfiguration): ModuleWithProviders<ReportApiModule> {
        return {
            ngModule: ReportApiModule,
            providers: [ { provide: ReportConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ReportApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ReportApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
